// seam over window.self !== window.top so tests can mock it (jsdom 26 locks those globals)
const isInIframe = (): boolean => window?.self !== window?.top;

export default isInIframe;
